export default "__VITE_ASSET__COwgIrCH__"